import React from 'react';

function RelateAllItemsDefault({ fill = '#545659', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.18734 12.1458H15.3332L12.6873 8.58329L10.5415 11.3958L9.12484 9.58329L7.18734 12.1458ZM5.4165 15.8333C5.08317 15.8333 4.7915 15.7083 4.5415 15.4583C4.2915 15.2083 4.1665 14.9166 4.1665 14.5833V2.91663C4.1665 2.58329 4.2915 2.29163 4.5415 2.04163C4.7915 1.79163 5.08317 1.66663 5.4165 1.66663H17.0832C17.4165 1.66663 17.7082 1.79163 17.9582 2.04163C18.2082 2.29163 18.3332 2.58329 18.3332 2.91663V14.5833C18.3332 14.9166 18.2082 15.2083 17.9582 15.4583C17.7082 15.7083 17.4165 15.8333 17.0832 15.8333H5.4165ZM5.4165 14.5833H17.0832V2.91663H5.4165V14.5833ZM2.9165 18.3333C2.58317 18.3333 2.2915 18.2083 2.0415 17.9583C1.7915 17.7083 1.6665 17.4166 1.6665 17.0833V4.16663H2.9165V17.0833H15.8332V18.3333H2.9165Z" fill={fill} />
    </svg>

  );
}

export default RelateAllItemsDefault;
